module.exports = __webpack_public_path__ + "static/media/19ESCAP45.3fd5432b.jpg";